import { Paper as MuiPaper, type PaperProps as MuiPaperProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

type Props = WithoutStyleOverrides<Omit<MuiPaperProps, 'variant' | 'elevation' | 'square'>>;

export function Paper(props: Props) {
  return <MuiPaper {...props} variant="outlined" />;
}

export type { Props as PaperProps };
